import React from 'react';

// Vertical left-hand navigation for a dashboard. `items` is an array of
// { key, label, icon }. Clicking an item calls onSelect(key).
const Sidebar = ({ items, activeKey, onSelect }) => {
    return (
        <nav className="dashboard-sidebar">
            {items.map(item => (
                <div
                    key={item.key}
                    className={`dashboard-sidebar-item ${activeKey === item.key ? 'active' : ''}`}
                    onClick={() => onSelect(item.key)}
                >
                    {item.icon} {item.label}
                </div>
            ))}
        </nav>
    );
};

export default Sidebar;
